import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NAV_ROUTES } from '../../constants/navRoutes';
import { SideNavProps } from './types';
import MobileNavBar from './MobileNavBar';
import DesktopNavBar from './DesktopNavBar';

const SideNav: React.FC<SideNavProps> = ({
  customWidth,
  options,
  isAdmin,
  username,
  onClickLogout,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openModule, setOpenModule] = useState<number | null>(null);
  const [selectedSubmodule, setSelectedSubmodule] = useState<string | null>(null);
  const [filteredOptions, setFilteredOptions] = useState<any[]>([]);

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  const handleModuleClick = (index: number, subOptions?: { label: string; path: string }[]) => {
    const isSubmoduleSelected = subOptions
      ?.map((option) => option.label)
      .includes(selectedSubmodule || '');
    if (isSubmoduleSelected && openModule !== null) {
      setOpenModule(null);
      return;
    }

    if (subOptions && subOptions.length) {
      setOpenModule(openModule === index ? null : index);
      if (!isSubmoduleSelected) {
        const originalOptions = [...filteredOptions];

        const clickedModule = filteredOptions.find(
          (option) => option.subOptions?.[0]?.label === subOptions[0].label,
        );

        const urlModuleParam = clickedModule?.label
          .toLowerCase()
          .replace(/ /g, '_')
          .replace(/\(|\)/g, '');

        setSelectedSubmodule(subOptions[0].label);
        setFilteredOptions(originalOptions);

        navigate(`${NAV_ROUTES.DASHBOARD}/${urlModuleParam}/${subOptions[0].path}`);
      }
    } else {
      setSelectedSubmodule(null);
      navigate(filteredOptions[index].path);
    }
  };

  const handleSubModuleClick = (path: string, label: string) => {
    setSelectedSubmodule(label);
    navigate(
      `${NAV_ROUTES.DASHBOARD}/${path.toLowerCase().replace(/ /g, '_').replace(/\(|\)/g, '')}`,
    );
  };

  const isCurrentRoute = (path: string | string[]): boolean => {
    if (Array.isArray(path)) {
      const id = location.pathname.split('/').pop() || '';
      return id ? path.includes(id) : false;
    }

    // For getting started the absolute path is checked.
    if (path.includes(NAV_ROUTES.GETTING_STARTED)) {
      return location.pathname === path;
    }

    return location.pathname.includes(path);
  };

  return (
    <>
      {/* Mobile View */}
      <MobileNavBar
        filteredOptions={filteredOptions}
        handleModuleClick={handleModuleClick}
        handleSubModuleClick={handleSubModuleClick}
        isCurrentRoute={isCurrentRoute}
        openModule={openModule}
        setOpenModule={setOpenModule}
        setSelectedSubmodule={setSelectedSubmodule}
        userName={username}
        isAdmin={isAdmin}
        customWidth={customWidth}
        onClickLogout={onClickLogout}
      />
      {/* Desktop View */}
      <DesktopNavBar
        filteredOptions={filteredOptions}
        handleModuleClick={handleModuleClick}
        handleSubModuleClick={handleSubModuleClick}
        isCurrentRoute={isCurrentRoute}
        openModule={openModule}
        setOpenModule={setOpenModule}
        setSelectedSubmodule={setSelectedSubmodule}
        userName={username}
        isAdmin={isAdmin}
        customWidth={customWidth}
        onClickLogout={onClickLogout}
      />
    </>
  );
};

export default SideNav;
